import React from 'react';
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';

// import Backdrop from '../../Backdrop/Backdrop';
import Folder from '../BucketComponents/Folder/Folder';
// import Modal from '../../Modal/Modal';
import Loader from '../Loader/Loader';

import { useStore } from '../../hook-store/store';
import * as uploadUtils from '../../utils/bucket/bucket-upload-util';
import { s3fileUploadLf } from '../../utils/large-file-upload/large-file-upload-utils';

import { BACKEND_URL, loginPageLink, signupPageLink } from '../../App';


// import { BACKEND_URL, loginPageLink, signupPageLink } from '../../../App';

// import './ResizerUpload.css';
// import "./tui-image-editor.css";
// import "./FileControl.css";

export default function UploadFileActionButton(props) {
  const {
    // showUploadMoadlHandler
    uploadPrefix,
    uploadFiles,
    onUploadSuccess,
    buttonStyle,
    buttonText,
    uploadApp,
  } = props;

  const [t] = useTranslation('translation');
  // console.log('UploadEditFile-props', props);

  const [store, dispatch] = useStore();
  const { 
    bucketName, 
    topLevels, 
    totalSizeGB, 
    limitGB,
    // selectedPrefix,
  } = store.bucketObjectStore;
  const { gLoading } = store.uiStore;
  // const { 
  //   resizedFiles,
  // } = store.imageResizerStore;

 
  const [isLoading, setIsLoading] = useState();


  useEffect(() => {
    if (gLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  },[gLoading]);



  const resizeImagesUploadHandler2 = async (path, files) => {
    try {
      // setIsLoading(true);
      dispatch('SET_GLOADING', true);

      let resultsForAction = {
        fileUpload: null,
      };


      console.log(path, files);
      // throw new Error('error-error');

      if (!files || files.length === 0) {
        throw new Error('upload file is required');
      }

      if (files.length > 10) {
        throw new Error('Upload limit is 10 file');
      }

      let uploadSizeGB = 0;
      // let limitGB = 0.1;

      for (const file of files) {
        uploadSizeGB = uploadSizeGB + file.size / 10**9;
      }

      if ((totalSizeGB + uploadSizeGB) > limitGB) {
        throw new Error('Total file sizes are more than limit');
      }
      // console.log(hasActiveSubscription, hasActiveSubscription2);


      let result;
      let addObjectList = [];
      let addKeys = [];
      const resultList = [];
      let fileIdx = 0;

      for (const file of files) {

        // //// skip no ext file
        // const nameSplits = file.name.split('.');

        // if (nameSplits.length < 2) {
        //   resultList.push({
        //     fileIdx: fileIdx,
        //     fileName: file.name,
        //     result: null,
        //   });
        //   fileIdx = fileIdx+1
        //   continue;
        // }


        result = await s3fileUploadLf(
          BACKEND_URL,
          localStorage.getItem('token'),
          path,
          file,
          bucketName,
          files.length,
          fileIdx,
          uploadApp,
          localStorage.getItem('customerId'),
          '',
        );

        console.log('result', result);
        if (result.data) {
          addObjectList = addObjectList.concat(result.data);
        }

        if (result.dataForMetadata && result.dataForMetadata.addKeys) {
          addKeys = addKeys.concat(result.dataForMetadata.addKeys)
        }

        resultList.push({
          fileIdx: fileIdx,
          fileName: file.name,
          result: result,
        });

        if (result) {
          resultsForAction.fileUpload = result;
        }

        fileIdx = fileIdx+1
        // console.log('result, addObjectList addKeys', addObjectList, addKeys)
      }

      // console.log('resultList', resultList);

      const successDataList = [];
      const failedDataList = [];

      for (const data of resultList) {
        if (data.result) {
          successDataList.push(data);
        } else {
          failedDataList.push(data);
        }
      }

      if (successDataList.length === 0) {
        throw new Error('no upload success file');
      }

      // setSelectedFiles(null);

      // const addedList = topLevels.concat(result.data.data);
      const addedList = topLevels.concat(addObjectList);
      dispatch('SET_TOPLEVELS', addedList);

      // setSelectedFiles([]);
      // setDroppedFiles([]);
      // setShowDropArea(false);

      dispatch('SET_OBJECTACTION', {
        actionType: 'file-upload',
        delete: false,
        add: true,
        result: resultsForAction,
      });

      // dispatch('SET_DATAFORMETADATA', result.data.dataForMetadata);
      dispatch('SET_DATAFORMETADATA', { addKeys: addKeys });
      
      dispatch('SHOW_NOTIFICATION', {
        status: '',
        title: `upload success. (success ${successDataList.length}, failed ${failedDataList.length})`,
        message: '',
      });

      setTimeout(() => {
        dispatch('CLEAR_NOTIFICATION');
      },1000 * 10);

      // setIsLoading(false);
      dispatch('SET_GLOADING', false);
      
      if (onUploadSuccess) {
        onUploadSuccess();
      }


    } catch(err) {
      console.log(err);

      // setSelectedFiles([]);
      // setDroppedFiles([]);

      //// set isUploadFailed to get services-info again
      dispatch('SET_ISUPLOADFAILED', true);

      dispatch('SHOW_NOTIFICATION', {
        status: 'error',
        title: `upload failed. ${err.message && err.message}`,
        message: '',
      });

      // setTimeout(() => {
      //   dispatch('CLEAR_NOTIFICATION');
      // },1000 * 10);

      
      // setIsLoading(false);
      dispatch('SET_GLOADING', false);
    }

  };
  
  let dispButtonText = (
    <span>
      {t('resizer16', 'upload files')}
    </span>
  );

  if (buttonText) {
    dispButtonText = (
      <span>
        {buttonText}
      </span>
    );
  }

  let uploadFileActionButtonBody;

  uploadFileActionButtonBody = (
    <div>
      <button className="btnBase"
        style={buttonStyle ? buttonStyle : null}
        disabled={uploadFiles.length === 0 || isLoading}
        // onClick={() => { saveImageToDisk(filePath); }}
        onClick={() => { 
          if (!isLoading) {
            resizeImagesUploadHandler2(
              uploadPrefix, 
              uploadFiles,
            );
          } 
        }}
      > 
        {dispButtonText}
        {/* {t('resizer16', 'upload files')} */}
      </button>
      {isLoading && (<Loader />)}
    </div>
  );


  return (
    <Fragment>
      <div>
        {uploadFileActionButtonBody}
      </div>
    </Fragment>
  );
}

